import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const AICharacteristicStyles = styled(OnboardingPage)`
  ion-content {
    --padding-top: 10px;
    --padding-bottom: 10px;
    --padding-start: 10px;
    --padding-end: 10px;
  }
`;
